import React, {memo} from "react";
import {Icon} from "@material-ui/core";


const RegistrationForServiceFooter = ({page, setPage}) => (
    <div className="registration-for-service__footer footer">
        <button className={`footer__btn${page === 1 ? ' _active' : ''}`} onClick={() => setPage(1)}>
            <Icon>post_add</Icon>
            <span>Запись</span>
        </button>
        <button className={`footer__btn${page === 3 ? ' _active' : ''} `} onClick={() => setPage(3)}>
            <Icon>perm_identity</Icon>
            <span>Профиль</span>
        </button>
        <button className={`footer__btn${page === 2 ? ' _active' : ''}`} onClick={() => setPage(2)}>
            <Icon>info</Icon>
            <span>О нас</span>
        </button>
        <button className={`footer__btn${page === 4 ? ' _active' : ''}`} onClick={() => setPage(4)}>
            <Icon>event_note</Icon>
            <span>Мои записи</span>
        </button>
    </div>
);

export default memo(RegistrationForServiceFooter);